module.exports = __webpack_public_path__ + "img/yilianGl2.401363f2.png";